import { CompsDataType } from 'dashboard409a/services/types';

export const getScalarOpinion = (companyId: number) => `/api/dashboard/company/${companyId}`;
export const findScalarOpinion = (dashboardId: number) => `/api/dashboard/${dashboardId}`;
export const updateScalarOpinion = (companyId: number) => `/api/dashboard/${companyId}`;
export const approveReportForClient = (cmdId: number) => `/api/dashboard/company/approve-for-clients/${cmdId}`;
export const getGpcComps = (dashboardId: number, dataType: CompsDataType) =>
  `/api/dashboard/${dashboardId}/gpc-comps?data_type=${dataType}`;
export const getCompanyRequestedInformation = (companyId: number) =>
  `/api/dashboard/company/${companyId}/requested-information`;
export const createInformationRequest = (companyId: number) =>
  `/api/dashboard/company/${companyId}/create-information-request/`;
export const getCurrentInformationRequests = (measurementDateId: number) =>
  `/api/dashboard/current-information-requests/${measurementDateId}`;
export const modifyExistingRequest = () => '/api/dashboard/company/modify-existing-request/';
export const createRequestedDocuments = () => '/api/dashboard/company/create-requested-documents/';
export const createQuestions = () => '/api/dashboard/company/create-questions/';
export const retrieveUpdateDestroyCompanyRequestedDocument = (requestedDocumentId: number) =>
  `/api/dashboard/companies/company-requested-document/${requestedDocumentId}`;
export const retrieveUpdateDestroyCompanyQuestion = (questionId: number) =>
  `/api/dashboard/companies/company-question/${questionId}`;

export default {
  getScalarOpinion,
  findScalarOpinion,
  updateScalarOpinion,
  approveReportForClient,
  getGpcComps,
  getCompanyRequestedInformation,
  createInformationRequest,
  getCurrentInformationRequests,
  modifyExistingRequest,
  createRequestedDocuments,
  createQuestions,
  retrieveUpdateDestroyCompanyRequestedDocument,
  retrieveUpdateDestroyCompanyQuestion,
};
